import { Injectable } from '@angular/core';
import { SignStickerDetail } from '../../../../model/sign/sticker/sign-sticker-detail';

@Injectable({
  providedIn: 'root'
})
export class SignStickerFactory {
  public createSignSticker(): SignStickerDetail {
    const toReturn = new SignStickerDetail();
    toReturn.examples = [];

    return toReturn;
  }
}
